__turbopack_context__.v({
  "illustration": "Illustration-module-scss-module__jGACZW__illustration",
  "large": "Illustration-module-scss-module__jGACZW__large",
  "large-upscale": "Illustration-module-scss-module__jGACZW__large-upscale",
  "normal": "Illustration-module-scss-module__jGACZW__normal",
  "normal-upscale": "Illustration-module-scss-module__jGACZW__normal-upscale",
  "small": "Illustration-module-scss-module__jGACZW__small",
  "small-upscale": "Illustration-module-scss-module__jGACZW__small-upscale",
});
